import React from 'react';
import Icon, { IconProps } from './Icon';

const BurgerIcon: React.FC<IconProps> = ({ size = 24, color = '#343B91', ...props }) => {
  return (
    <Icon size={size} color={color} viewBox="0 0 24 24" {...props}>
      <path
        d="M3 12H21M3 6H21M3 18H21"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Icon>
  );
};

export default BurgerIcon;

